import styled from 'styled-components';
import {tabletMedia} from '../../../../globalVariables/GlobalVariables';

export const wrap = styled.div`
    display: flex;
    flex-direction: column;

    ${tabletMedia} {
        background: var(--TA-color-bg-base);
        margin-inline: -10px;
    }
`;

export const contentArea = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--space-lg);
    padding: var(--space-lg) 0;
`;

export const toolbarRow = styled.div`
    display: none;

    ${tabletMedia} {
        height: 32px;
        padding-inline-start: var(--space-xs);
        padding-inline-end: var(--space-lg);
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: var(--space-sm);
    }
`;

export const filterRow = styled.div`
    padding: 0 var(--space-lg);
`;

export const filterCard = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-lg);
    padding: var(--space-md);
    background: var(--TA-color-bg-base);
    border: 1px solid var(--color-border-subtle);
    border-radius: var(--radius-md);
`;

export const searchPill = styled.div`
    flex: 1;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: var(--space-sm);
    padding: 0 var(--space-lg);
    background: var(--TA-color-bg-surface-default);
    border: none;
    border-radius: 100px;
    color: var(--color-text-default);
    font-size: var(--font-size-button-category);
    direction: ltr;
`;

export const searchInput = styled.input`
    flex: 1;
    min-width: 0;
    height: 100%;
    border: none;
    background: transparent;
    outline: none;
    color: inherit;
    font: inherit;
    text-align: inherit;
    padding: 0;

    &::placeholder {
        color: var(--color-text-default);
    }
`;
